import applyStyles from '@root/tabulator/RowFormatters/_applyStyles'

export default function (row, cell, params = {}) {
  function shouldApply({ from = null, to = null }) {
    let data = cell.getValue();

    data = data.replace(/[^0-9]/g, '');

    if (from !== null && to !== null) {
      return data >= from && data <= to;
    }

    if (from !== null) {
      return data >= from;
    }

    if (to !== null) {
      return data <= to;
    }

    return false;
  }

  applyStyles(shouldApply, row.getElement(), cell.getElement(), params);
}